export const loginUser = (userData) => {
  return fetch("/api/users/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userData),
  });
};

export const getRating = async (email) => {
  try {
    const response = await fetch("/api/ratings/submit-rating", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      throw new Error("Failed to submit rating.");
    }

    const data = await response.json();
    return data.message; // Return the message from the server
  } catch (error) {
    console.error("Error:", error);
    return error.message; // Return the error message
  }
};

export const getEmailContact = async () => {
  try {
    const response = await fetch("/api/ratings/get-rating-emails");
    if (!response.ok) {
      throw new Error("Failed to fetch rating emails.");
    }
    const data = await response.json();
    return data; // Return the list of emails
  } catch (error) {
    console.error("Error fetching rating emails:", error);
    return [];
  }
};
// utils/api.js

export const submitFeedback = async (feedbackData) => {
  try {
    const response = await fetch("/api/ratings/save-feedback", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(feedbackData),
    });

    if (!response.ok) {
      throw new Error("Failed to submit feedback.");
    }

    const data = await response.json();
    return data.message; // Return the success message
  } catch (error) {
    console.error("Error submitting feedback:", error);
    throw error; // Throw the error to handle it in the component
  }
};
// utils/api.js

export const getFeedbackList = async () => {
  try {
    const response = await fetch("/api/ratings/get-feedback");
    if (!response.ok) {
      throw new Error("Failed to fetch feedback.");
    }
    const data = await response.json();
    if (!Array.isArray(data)) {
      throw new Error("Feedback data is not an array.");
    }
    return data;
  } catch (error) {
    console.error("Error fetching feedback:", error);
    throw error;
  }
};
export const createUser = (userData) => {
  return fetch("/api/users/signup", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userData),
  });
};

export const updateUser = (payload, userId) => {
  const token =
    localStorage.getItem("drhvac_session") || localStorage.getItem("id_token");

  return fetch(`/api/users/${userId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}), // ✅ add token
    },
    body: JSON.stringify(payload),
  });
};


export const getPendingUsers = () => {
  const token =
    localStorage.getItem("drhvac_session") || localStorage.getItem("id_token");

  return fetch("/api/users/pending", {
    method: "GET",
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
};

//password

export const forgotPassword = async (payload) => {
  return fetch("/api/users/forgot-password", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
};

export const updatePassword = ({ email, otp, newPassword }) => {
  console.log({ email, otp, newPassword });
  return fetch("/api/users/update-password", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email,
      otp,
      newPassword,
    }),
  });
};
export const validateOTP = async (payload) => {
  return fetch("/api/users/check-otp", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
};
